import { useState } from "react";
import { servicesData } from "@/mocks/homeData";

export default function ServicesSection() {
  const [activeTab, setActiveTab] = useState("technology");
  const activeService = servicesData.tabs.find((t) => t.id === activeTab);

  return (
    <section id="services" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
            What We Offer
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
            {servicesData.headline}
          </h2>
          <p className="text-foreground-700 leading-relaxed">
            {servicesData.subheadline}
          </p>
        </div>

        <div className="flex justify-center mb-10 md:mb-12">
          <div className="inline-flex flex-wrap justify-center p-1 rounded-full bg-background-200/70 border border-background-300/60 gap-1">
            {servicesData.tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 md:px-5 py-2.5 text-sm font-semibold rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {activeService && (
          <div className="animate-fadeIn">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h3 className="font-heading font-semibold text-xl md:text-2xl text-foreground-950 mb-3">
                {activeService.title}
              </h3>
              <p className="text-foreground-700 leading-relaxed">
                {activeService.description}
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {activeService.offerings.map((item) => (
                <div
                  key={item.title}
                  className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all hover:-translate-y-1"
                >
                  <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-xl md:text-2xl text-primary-500`} />
                  </div>
                  <h4 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2">
                    {item.title}
                  </h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}